import styled from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import SolarTopNav from '@/components/solarSumPage/solartopnav';
import MobileSolarTopNav from '@/componentsH5/solarSumPage/solartopnav';

export interface ISolutionsNavProp {
    navList: {
        name: string;
        imgSrc: string;
        detLink: string;
        icons: JSX.Element;
        tag: JSX.Element | string;
    }[];
    query?: string;
}

export default function SolutionsNav({ query = '', navList }: ISolutionsNavProp) {
    const { isMobile } = useGlobal();

    return (
        <div className={`${isMobile ? styled.solutions_mobilenav : ''} ${styled.solutions_nav}`}>
            {isMobile ? (
                <MobileSolarTopNav
                    query={query}
                    navList={navList}
                    config={{
                        spaceBetween: 0,
                        loop: false,
                    }}
                />
            ) : (
                <SolarTopNav query={query} navList={navList} />
            )}
        </div>
    );
}
